import { ArgsType, Field } from '@nestjs/graphql'
import { BaseGetByIdArgs } from '../base/baseGetById.args'

@ArgsType()
export class ArcTeamGetByIdArgs extends BaseGetByIdArgs<ArcTeamGetByIdArgs> {
  @Field(t => Boolean, { nullable: true })
  getAverageRating?: boolean
}
